import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';
import { H2 } from '@rikstv/shared-components';

import styles from './CoverPageSectionHeader.module.css';

export const CoverPageSectionHeader: FCC = ({ children }) => (
  <H2 className={styles.coverpageSectionHeader} lookLike="title-3">
    {children}
  </H2>
);
